const getThresholdValueAqi = (level) => {
  switch (level) {
    case 1:
      return {
        threshold: 'Good',
        color: '#6CB2A2',
        OutlineColor: '#FFFFFF',
      }
    case 2:
      return {
        threshold: 'Moderate',
        color: '#FFFFF0',
        OutlineColor: '#0D5E4F',
      }
    case 3:
      return {
        threshold: 'Unhealthy for Sensitive Groups',
        color: '#FFA977',
        OutlineColor: '#AD8D01',
      }
    case 4:
      return {
        threshold: 'Unhealthy',
        color: '#FC7261',
        OutlineColor: '#990000',
      }
    case 5:
      return {
        threshold: 'Very Unhealthy',
        color: '#F03028',
        OutlineColor: '#FFFFFF',
      }
      case 5:
      return {
        threshold: 'Hazardous',
        color: '#C40000',
        OutlineColor: '#FFFFFF',
      }
    default:
      return {
        threshold: 'No Data',
        color: '#E5E5E6',
        OutlineColor: '#7D7F81',
      }
  }
}

export default getThresholdValueAqi
